<template>
    <b-form-row>
        <b-modal size="md" button-size="sm" hide-footer v-model="showModal" :title="prefix + title" @hidden="cancelar">

            <b-form @submit.prevent="save">
                <b-card bg-variant="light">
                    <lg-form-input invalidFeedback="Informe uma descrição válida!" description=" "
                        :error="$v.form.descricao" v-model="form.descricao" label="Descrição:*" cols="12" />


                    <lg-form-input invalidFeedback="Informe uma descrição válida!" description=" "
                    v-model="form.codigo" label="Identificador:" cols="12" />

                    <lg-finder-page-tipo-local-armazenamento id="finderTipoLocalArmazenamento" :label="'Tipo:*'"
                        v-model="form.tipoLocalArmazenamento" @close="(item) => (form.tipoLocalArmazenamento = item)"
                        ref="finderTipoLocalArmazenamento" title="Busca de tipo local de armazenamento">
                    </lg-finder-page-tipo-local-armazenamento>

                    <b-form-row>
                        <b-form-group label="Status:*" class="ml-3">
                            <b-form-radio-group v-model="form.situacao" :options="statusOptions" size="sm"
                                name="status-inline"></b-form-radio-group>
                        </b-form-group>
                    </b-form-row>

                    <b-tabs>

                        <b-tab title="Unidade Administrativa">

                            <b-form-row>
                                <b-col cols="12" class="text-right">
                                    <b-button id="adicionar" class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill
                                        variant="primary" @click="addUnidade">
                                        <div class="btn-size-alinhamento">
                                            <b-icon icon="plus" />
                                        </div>
                                        <b-tooltip target="adicionar"
                                            title="Adicionar Unidade Administrativa..."></b-tooltip>

                                    </b-button>
                                </b-col>
                            </b-form-row>


                            <b-table id="t-pessoas" responsive="sm" stacked="sm" small outlined sticky-header show-empty
                                head-variant="light" :items="form.departamentos" :fields="fields"
                                style="max-height: 200px; overflow: auto !important;">
                                <template #empty>
                                    <h6 style="text-align: center">Nenhuma Unidade Administrativa vinculada</h6>
                                </template>
                                <template v-slot:cell(remover)="row">
                                    <b-button :id="row.index + 'excluirUnidade'" class=" my-2" size="sm" pill
                                        variant="primary" @click="removeUnidade(row.item)">
                                        <b-icon icon="trash-fill" />
                                        <b-tooltip :target="row.index + 'excluirUnidade'"
                                            title="Remover..."></b-tooltip>

                                    </b-button>
                                </template>

                                <template v-slot:cell(classificacao)>
                                    <span>Secundária</span>
                                </template>
                            </b-table>


                        </b-tab>

                        <b-tab title="Fiscais Responsáveis">

                            <b-form-row>
                                <b-col cols="12" class="text-right">
                                    <b-button id="adicionar-fiscal" class="ml-3 mr-2 my-2" size="sm"
                                        style="height: 20px" pill variant="primary" @click="abrirModalPessoa">
                                        <div class="btn-size-alinhamento">
                                            <b-icon icon="plus" />
                                        </div>
                                        <b-tooltip target="adicionar-fiscal" title="Adicionar Fiscal..."></b-tooltip>

                                    </b-button>
                                </b-col>
                            </b-form-row>


                            <b-table id="t-pessoas-fiscais" responsive="sm" stacked="sm" small outlined sticky-header
                                show-empty head-variant="light" :items="form.fiscais" :fields="fieldsFiscais"
                                style="max-height: 200px; overflow: auto !important;">
                                <template #empty>
                                    <h6 style="text-align: center">Nenhum Fiscal Responsável vinculado</h6>
                                </template>
                                <template v-slot:cell(remover)="row">
                                    <b-button :id="row.index + 'excluirUnidade'" class=" my-2" size="sm" pill
                                        variant="primary" @click="removeFiscais(row.item)">
                                        <b-icon icon="trash-fill" />
                                        <b-tooltip :target="row.index + 'excluirUnidade'"
                                            title="Remover..."></b-tooltip>

                                    </b-button>
                                </template>

                                <template v-slot:cell(classificacao)>
                                    <span>Secundária</span>
                                </template>
                            </b-table>


                        </b-tab>
                    </b-tabs>

                    <b-form-row>

                        <b-col cols="3"></b-col>
                        <b-col cols="6" class="text-center">
                            <b-button id="salvarLocalCadastro" class=" my-2" size="sm" pill variant="success"
                                @click="save">
                                <b-icon icon="check-circle" />
                                <b-tooltip target="salvarLocalCadastro" title="Salvar"></b-tooltip>

                            </b-button>

                            <b-button id="cancelarLocalCadastro" class=" my-2 ml-2" size="sm" pill variant="danger"
                                @click="cancelar">
                                <b-icon icon="x-circle" />
                                <b-tooltip target="cancelarLocalCadastro" title="Cancelar"></b-tooltip>

                            </b-button>
                        </b-col>
                        <b-col cols="3"></b-col>

                    </b-form-row>


                </b-card>

            </b-form>
        </b-modal>
        <ModalPageUnidadeAdministrativa :id="idPai + ' - finder'" v-if="showUnidade" @onselect="addUnidadeSelect"
            :prefix="prefix + title + ' > '"></ModalPageUnidadeAdministrativa>

        <Lg-finder-page-pessoa-modal @onSelect="addFiscais" ref="finderPessoaAlmoxarifadoForm"
            :prefix="prefix + title + ' > '"></Lg-finder-page-pessoa-modal>

    </b-form-row>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import ModalPageUnidadeAdministrativa from "@/core/components/Modals/ModalPageUnidadeAdministrativa.vue";
import ResourceService from "@/core/api/ResourceService";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { FormResourceMixin } from "@/core/mixins/resource";
import LgFinderPageTipoLocalArmazenamento from "@/components/Finders/LgFinderPageTipoLocalArmazenamento.vue";
import LgFinderPagePessoaModal from "@/components/Modal/LgFinderPagePessoaModal.vue";

export default {
    components: {
        LgFormInput,
        LgFinderPageTipoLocalArmazenamento,
        ModalPageUnidadeAdministrativa,
        LgFinderPagePessoaModal
    },
    props: {
        idPai: {
            type: Number,
            default: null,
        },


        id: Number,
        departamentoId: Number,
        prefix: {
            type: String,
            default: "",
        },
    },
    mixins: [FormResourceMixin],
    validations: {
        form: {

            departamentos: { required },
            descricao: { required },
            tipoLocalArmazenamento: { required },
            situacao: { required },
        },
    },
    data() {
        return {
            showUnidade: false,
            showPessoa: false,

            fields: [
                {
                    key: 'sigla', label: 'Sigla', thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },
                {
                    key: 'descricao', label: 'Descrição', thStyle: " font-size: 16px; ",
                    tdClass: "text-center ",
                },
                {
                    key: 'classificacao', label: 'Classificação', thStyle: "width: 1rem; font-size: 16px; ",
                    tdClass: "text-center ",
                },


                { key: 'remover', label: ' ' }

            ],
            fieldsFiscais: [
                {
                    key: 'nome', label: 'Nome', thStyle: " font-size: 16px; ",
                    tdClass: "text-center ",
                },

                { key: 'remover', label: ' ' }

            ],
            statusOptions: [
                { text: "Ativo", value: 1 },
                { text: "Inativo", value: 0 },
            ],
            showModal: true,
            title: "Cadastro",
            form: {
                codigo: "",
                fiscais: [],
                departamentos: [],
                descricao: "",
                tipoLocalArmazenamento: { id: null, descricao: '' },
                situacao: 1,
            },
        };
    },
    async beforeMount() {
        this.$service = new ResourceService(`/api/local-armazenamento`);
    },
    async mounted() {
        if (this.id) {
            const { data } = await this.$service.findById(this.id);
            this.form.tipoLocalArmazenamento.descricao = data.tipoLocalArmazenamento.descricao;
            this.form.tipoLocalArmazenamento.id = data.tipoLocalArmazenamento.id;
            this.form = data;
        } else {
            this.form.situacao = 1;
        }
    },
    methods: {
        async removeFiscais(fiscal) {
            this.form.fiscais.splice(
                this.form.fiscais.indexOf(fiscal),
                1
            );
        },

        async addFiscais(fiscal) {
            this.$refs.finderPessoaAlmoxarifadoForm.showModal = false;

            const found = this.form.fiscais.find(
                item => item.id === fiscal.id
            );

            if (found) {
                this.$notify({
                    type: "danger",
                    message: "Fiscal já vinculado!",
                });
                return;
            }

            this.form.fiscais.push({
                id: fiscal.id,
                nome: fiscal.nome,
            });
        },
        addUnidade() {
            this.showUnidade = true;
        },
        abrirModalPessoa() {
            this.$refs.finderPessoaAlmoxarifadoForm.show();
        },
        async save() {
            if (!this.formIsValid || (this.form.tipoLocalArmazenamento == null || this.form.tipoLocalArmazenamento.id == null)) {
                this.$v.$touch();
                this.$notify({
                    type: "danger",
                    message: "Verifique os campos de cadastro.",
                });
                return;
            }


            if (this.form.tipoLocalArmazenamento == null || this.form.tipoLocalArmazenamento.id == null) {
                this.$v.$touch();
                this.$notify({
                    type: "danger",
                    message: "Selecione o Tipo de Local de Armazenamento",
                });
                return;
            }


            if (this.form.departamentos == null || this.form.departamentos.length == 0) {
                this.$v.$touch();
                this.$notify({
                    type: "danger",
                    message: "Selecione um Departamento para vincular",
                });
                return;
            }



            this.form.departamentoId = this.departamentoId;
            try {
                this.form.idPai = this.idPai;
                await this.$saveResource(this.form);
                this.cancelar();

            }
            catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data,
                });

            }
        },
        cancelar() {
            this.$emit("close");
        },
        async removeUnidade(almoxarife) {
            this.form.departamentos.splice(
                this.form.departamentos.indexOf(almoxarife),
                1
            );
        },
        addUnidadeSelect(unidade) {
            this.showUnidade = false;

            const found = this.form.departamentos.find(
                item => item.id === unidade.id
            );

            if (found) {
                this.$notify({
                    type: "danger",
                    message: "Unidade Administrativa já vinculada!",
                });
                return;
            }


            this.form.departamentos.push(unidade);
        }

    },
};
</script>
